module.exports = __webpack_public_path__ + "static/media/twitter.a91a9eaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.svg
// module id = 1220
// module chunks = 0